import { Button, Segmented, Switch } from 'antd';
import { useContext, useState } from 'react';
import MainAppContext from 'contexts/MainAppContext';
import MapViewContext from 'contexts/MapViewContext';
import ProductsContext from 'contexts/ProductsContext';
import { Role, ViewMode } from 'types/app.types';
import { AppstoreOutlined, SettingOutlined } from '@ant-design/icons';
import { ReactComponent as LayersIcon } from 'assets/icons/layers.svg';
import Icon from '@ant-design/icons/lib/components/Icon';
import styles from './index.module.scss';
import SettingsDrawer from '../SettingsDrawer';

const { wrapper } = styles;

function ViewModeMenu() {
  const [isDrawerVisible, setIsDrawerVisible] = useState<boolean>(false);

  const {
    viewMode, setViewMode, syncLayers, setSyncLayers, crossSectionMode,
  } = useContext(MainAppContext);
  const { map } = useContext(MapViewContext);
  const { selectedProducts } = useContext(ProductsContext);
  const { role } = useContext(MainAppContext);

  const handleOnButtonClick = (mode : ViewMode) => {
    setViewMode(mode);
    map?.updateSize();
  };
  return (
    <div className={wrapper}>
      {role === Role.METEO && (
      <Segmented
        options={[
          {
            label: 'Tiles',
            value: 'tile',
            disabled: selectedProducts.length < 2 || crossSectionMode,
            icon: <AppstoreOutlined />,
          },
          {
            label: 'Layers',
            value: 'layer',
            icon: <Icon component={LayersIcon} />,
          },
        ]}
        onChange={(value) => {
          handleOnButtonClick(value as ViewMode);
        }}
        defaultValue={viewMode}
      />
      )}
      <Button icon={<SettingOutlined />} type="default" onClick={() => setIsDrawerVisible(true)}>Settings</Button>
      {viewMode === 'tile' && <Switch checked={syncLayers} onChange={(checked) => setSyncLayers(checked)} checkedChildren="Sync tiles" unCheckedChildren="Sync tiles" />}
      <SettingsDrawer
        open={isDrawerVisible}
        onClose={() => setIsDrawerVisible((prev) => !prev)}
      />
    </div>
  );
}

export default ViewModeMenu;
